import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { canAccessPath, getDefaultHomePath } from "../../utils/userPermissions";

interface RoleRouteGuardProps {
  children: React.ReactNode;
}

export function RoleRouteGuard({ children }: RoleRouteGuardProps) {
  const location = useLocation();
  const userType = useAppSelector((s) => s.user.info?.type);

  if (!canAccessPath(userType, location.pathname)) {
    return <Navigate to={getDefaultHomePath(userType)} replace />;
  }

  return <>{children}</>;
}
